import { Stack, type StackProps } from "@mui/material";
import { forwardRef } from "react";

import { mergeSxProps } from "../../Mui";
import { type ProblematicMuiPackagingProps } from "../../Mui/types";

/**
 * @deprecated Use the ListItem component from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
export type OlProps = Omit<ProblematicMuiPackagingProps<StackProps<"ol">>, "component">;

/**
 * @deprecated Use the ListItem component from cbh-mobile-app's redesign system (ui-components has been removed from cbh-core) instead.
 */
export const Ol = forwardRef<HTMLOListElement, OlProps>((props, ref) => {
  const { sx } = props;
  return (
    <Stack
      {...props}
      ref={ref}
      sx={mergeSxProps({ paddingLeft: 2 }, sx)}
      spacing={1}
      component="ol"
    />
  );
});

Ol.displayName = "Ol";
